import React from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import useAutoTimer from '../../hooks/useAutoTimer';
import { ChicletRow } from '../ReviewsCarousel/ChicletRow';
import styles from './ReferralTestimonials.module.scss';

interface Testimonial {
  quote: string;
  author: string;
}

const TESTIMONIALS: Testimonial[] = [
  {
    quote:
      'Fi literally saved my dog\u2019s life. He slipped his leash and I tracked him in real time until I found him.',
    author: 'Jordan M.',
  },
  {
    quote: 'Worth every penny. Fi helped us find our dog after she bolted during a thunderstorm.',
    author: 'Chris B.',
  },
  {
    quote: 'It\u2019s amazing to see exactly where Burt is all day and how much he\u2019s moving.',
    author: 'David K.',
  },
  {
    quote: 'I was delighted by the app, how clean the app was.',
    author: 'Haley S.',
  },
  {
    quote: 'Our gate was left open and Fi alerted us immediately. We had her back in under 10 minutes.',
    author: 'Rachel W.',
  },
];

const CAROUSEL_INTERVAL_MS = 5000;

export default function ReferralTestimonials() {
  const { current, setCurrent } = useAutoTimer({
    total: TESTIMONIALS.length,
    autoproceedInterval: CAROUSEL_INTERVAL_MS,
  });

  const testimonial = TESTIMONIALS[current];

  return (
    <section className={styles.container}>
      <SwitchTransition mode="out-in">
        <CSSTransition
          key={testimonial.author}
          addEndListener={(node, done) => {
            node.addEventListener('transitionend', done, false);
          }}
          classNames={{
            enter: styles.fadeEnter,
            enterActive: styles.fadeEnterActive,
            exit: styles.fadeExit,
            exitActive: styles.fadeExitActive,
          }}
        >
          <div className={styles.testimonial}>
            <p className={styles.quote}>{`\u201C${testimonial.quote}\u201D`}</p>
            <p className={styles.attribution}>{testimonial.author}</p>
          </div>
        </CSSTransition>
      </SwitchTransition>
      <ChicletRow value={current} total={TESTIMONIALS.length} onChicletClick={setCurrent} />
    </section>
  );
}
